import { useContext } from "react";
import { MachineSetupContextState } from "./MachineSetupContextProvider";

const useMachineSetupContextState = () => {
   const context = useContext(MachineSetupContextState);
   if (context === undefined) {
      throw new Error("useMachineSetupContextState was used outside of it's provider");
   }
   return context;
};

export { useMachineSetupContextState };
